
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface JUVBadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'status' | 'credit' | 'membership' | 'treatment';
  className?: string;
}

const JUVBadge = ({ children, variant = 'default', className }: JUVBadgeProps) => {
  const variants = {
    default: 'bg-juv-rose-clay text-juv-deep-chestnut',
    status: 'bg-green-100 text-green-800 border-green-200',
    credit: 'bg-juv-terracotta text-white',
    membership: 'bg-juv-gradient-primary text-white',
    treatment: 'bg-juv-soft-blush text-juv-deep-chestnut border-juv-rose-clay'
  };

  return (
    <Badge 
      className={cn(
        'px-3 py-1 rounded-full font-medium text-xs tracking-wide',
        variants[variant],
        className
      )}
    >
      {children}
    </Badge>
  );
};

export default JUVBadge;
